module.exports = __webpack_public_path__ + "img/sweden-blood-diseases-female.a830eeb7.png";